// --------------------------------
// Copyright (c) 2023 Eco8 S.r.l.
// --------------------------------
import React, { useState, useEffect } from "react";
import { View, Text, StyleSheet, TouchableOpacity } from "react-native";
import { Table, Row, Rows } from "react-native-table-component";
import colors from "../../../../config/colors";
import fonts from "../../../../config/fonts";
import { formatDate } from "../../../../utils/utils";

const DataTable = ({
    data,
    getTranslation,
    //formatDate,
    second,
    shared,
    direction,
    dateFrom,
    dateTo,
}) => {
    const [currentPage, setCurrentPage] = useState(1);
    const rowsPerPage = 5;

    const totalPages = Math.ceil((data?.length ?? 0) / rowsPerPage);

    useEffect(() => {
        // pagine vanno da 1 a totalPages (compresi)
        if (currentPage > totalPages && currentPage !== totalPages) {
            setCurrentPage(totalPages);
        } else if (currentPage < 1 && currentPage !== 0) {
            setCurrentPage(1);
        }
    }, [totalPages, currentPage]);

    if (data) {
        console.log("\n\nSELECT [Id], [FromDepositId], [ToDepositId], [Status], [ContentType], [PlanDate], [ConfirmDate], [StartDate], [EndDate], [DoneDate], [PlannedQuantity], [LoadedQuantity], [ConfirmedQuantity] FROM TRANSFERS (nolock) WHERE ID IN (" + data.map(a => a.id).join(", ") + ");\n\n");
    }

    if (data?.length == 0 && dateFrom) {
        return (
            <View style={styles.container}>
                <Text style={styles.message}>
                    {getTranslation("Nessun Dato Disponibile")}
                </Text>
            </View>
        );
    }

    let tableHead = [];
    let tableData = [];

    // sembra che second non accada mai perché viene impostato così solo da DataTableComponent2, che non viene mai utilizzato
    if (second) {
        tableHead = [
            getTranslation("Data"),
            getTranslation("Materiale"),
            getTranslation("Quantità [Kg]"),
            getTranslation("Modalità di Arrivo"),
        ];
        tableData = data.map((item) => [
            formatDate(item.endDate),
            getTranslation(item.contentType),
            item.quantity.toString(),
            getTranslation(item.modality),
        ]);
    } else {
        tableHead = [
            // getTranslation("ID"),
            // getTranslation("ContentType"),
            // getTranslation("Modality"),
            // getTranslation("From"),
            // getTranslation("To"),
            getTranslation("Data"),
            getTranslation("Quantità [Kg]")
        ];
        tableData = data.map((item) => [
            // item.id,
            // item.contentType,
            // item.modality,
            // item.fromDepositNameWithInfo,
            // item.toDepositNameWithInfo,
            formatDate(item.endDate),
            item.quantity.toString(),
        ]);
    }

    if (shared) {
        if (direction === "OUT") {
            tableHead = [
                // getTranslation("ID"),
                // getTranslation("ContentType"),
                // getTranslation("Modality"),
                // getTranslation("From"),
                // getTranslation("To"),
                getTranslation("Data"),
                getTranslation("Quantità [Kg]"),
                getTranslation("Prelevato da"),
            ];
            tableData = data.map((item) => [
                // item.id,
                // item.contentType,
                // item.modality,
                // item.fromDepositNameWithInfo,
                // item.toDepositNameWithInfo,
                formatDate(item.endDate),
                item.quantity.toString(),
                item.to.depositName
            ]);
        } else {
            tableHead = [
                // getTranslation("ID"),
                // getTranslation("ContentType"),
                // getTranslation("Modality"),
                // getTranslation("From"),
                // getTranslation("To"),
                getTranslation("Data"),
                getTranslation("Quantità [Kg]")
            ];
            tableData = data.map((item) => [
                // item.id,
                // item.contentType,
                // item.modality,
                // item.fromDepositNameWithInfo,
                // item.toDepositNameWithInfo,
                formatDate(item.endDate),
                item.quantity.toString(),
            ]);
        }
    }

    if (currentPage === 0 && totalPages > 0) {
        setCurrentPage(1);
    }

    const startIndex = (currentPage - 1) * rowsPerPage;
    const currentTableData = tableData.slice(
        startIndex,
        startIndex + rowsPerPage
    );

    return (
        currentTableData?.length && (
            <View style={styles.container}>
                <Table borderStyle={styles.tableBorder}>
                    <Row
                        data={tableHead}
                        style={styles.head}
                        textStyle={[
                            styles.text,
                            { color: colors.white, fontWeight: "bold" },
                        ]}
                    />
                    <Rows data={currentTableData} textStyle={styles.text} />
                </Table>
                <View style={styles.pagination}>
                    <TouchableOpacity
                        onPress={() => setCurrentPage(currentPage - 1)}
                        disabled={currentPage === 1}
                        style={[
                            styles.pageButton,
                            currentPage === 1 && styles.disabledButton,
                        ]}
                    >
                        <Text style={styles.pageButtonText}>{"<"}</Text>
                    </TouchableOpacity>
                    <Text style={styles.pageInfo}>
                        {getTranslation("Seite")} {currentPage} {getTranslation("von")}{" "}
                        {totalPages}
                    </Text>
                    <TouchableOpacity
                        onPress={() => setCurrentPage(currentPage + 1)}
                        disabled={currentPage === totalPages}
                        style={[
                            styles.pageButton,
                            currentPage === totalPages && styles.disabledButton,
                        ]}
                    >
                        <Text style={styles.pageButtonText}>{">"}</Text>
                    </TouchableOpacity>
                </View>
            </View>
        )
    );
};

const styles = StyleSheet.create({
    container: {
        flex: 1,
    },
    message: {
        marginLeft: 8,
        fontSize: 20,
        color: colors.white,
        textAlign: "center",
        justifyContent: "center",
        fontWeight: "bold",
        fontFamily: fonts.regular,
    },
    head: {
        height: 40,
        backgroundColor: colors.green,
    },
    text: {
        margin: 6,
        fontFamily: fonts.regular,
    },
    tableBorder: {
        borderWidth: 1,
        borderColor: "#c8e1ff",
    },
    pagination: {
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        marginTop: 10,
    },
    pageButton: {
        padding: 10,
        backgroundColor: colors.white,
        marginHorizontal: 5,
        borderRadius: 5,
    },
    disabledButton: {
        backgroundColor: colors.grey,
    },
    pageButtonText: {
        color: colors.green,
        fontSize: 18,
        fontWeight: "bold",
        fontFamily: fonts.regular,
    },
    pageInfo: {
        fontSize: 16,
        fontFamily: fonts.regular,
    },
});

export default DataTable;
